import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import showformmodel from "../showformmodel/showformmodel.vue" 

export default {
  name: "ActivityFormsModal",

  components: { customModal , showformmodel },

  props: {
    soaId: String
  },

  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      soaItem: {
        eCRF: []
      },
      eCRFDATA:[],
      setshowActivityFormModal: false,
      currentform: "",

    };
  },

  mounted() {
    if (this.soaId) {
      this.getSoA();
    }
  },

  emits: ["closeModal"],

  methods: {
    closeModal() {
      this.$emit("closeModal");
    },

   async gotoform(formid) {
    console.log("Selected form ID:", formid);
      this.currentform = formid;      
      this.setshowActivityFormModal = true;
    },
     closeformActivityModal() {
      this.currentform = "";
      this.setshowActivityFormModal = false;

    },
    async getSoA() {
      try {
        const res = await axios.get(
          `${this.baseurl}/management/study/getsoa?Id=${this.soaId}`,
          {
            headers: {
              Authorization: `Bearer ${store.getters.getIdToken}`,
              "Content-Type": "application/json"
            }
          }
        );

        this.soAItem = res.data || { eCRF: [] };
        this.eCRFDATA = res.data.eCRF || [];


      } catch (err) {
        console.log("error getting SoA", err);
      }
    },
  
  }
};